import getRandomNumber from 'random-number';

export const getRandomPhoneNumberWithPrefix = (phonePrefix = '') =>
  `+${phonePrefix}${String(getRandomNumber({ min: 111111111, max: 999999999, integer: true }))}`;
